<template>
    <div class="help-center-content">
        <h4>推广方法</h4>
        <p class="title">1.	如何推广我的录制作品呢？</p>
        <p class="content"><strong>首先，上传成功后立即分享节目，获取更多播放机会。</strong>
            <br>当你的节目通过审核，收到提醒，此时是不是已经迫不及待地要与你的好友或者粉丝分享你的声音作品了呢？那就立刻分享到 微博、微信、QQ空间等，获取第一批高播放量。<br>
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_3.png`"  style="width: 460px;height: 190px;">
        <p class="content"><strong>其次，利用微信公众号推广利器——微电台。</strong>
            <br>使用微电台进行简单的设置，就可以让微信公众号粉丝和微信好友都来收听你的节目啦。同步增加播放量就是这么简单！提示：您可以在喜马拉雅FM网端“管理中心”进行个性化设置、获取微电台网址，以及了解相关教程。
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_6.png`"  style="width: 390px;height: 410px;">
        <p class="content"><strong>再次，引导粉丝订阅。</strong>
            <br>拥有更多粉丝与订阅才能带来长期稳定的播放量。您可以在节目中提示听众点击”订阅“按钮订阅您的专辑哦，也可以分享专辑给您的朋友们“求订阅”！
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_7.png`"  style="width: 474px;height: 200px;">
        <p class="title">2. 如何申请Podcast服务？</p>
        <p class="content"><strong>申请Podcast服务，需要满足以下几个要求：</strong>
            <br>1.请确保你希望提交的专辑至少有3期节目。 2.准备好一张1400*1400像素以上的图片作为封面。3.我们鼓励原创内容，如有侵权内容可能无法通过。 4.合理的节目更新频率可以让你有效提升收听率。
            <br><br><strong>申请Podcast服务的流程如下：</strong>
            <br>您需要通过喜马拉雅网站网页端进行申请流程。进入方式：个人主页—管理中心—推广中心—Podcast服务随后即可点击“新建申请”，按照流程进行下一步操作：
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_8.png`"  style="width: 590px;height: 300px;">
        <p class="content"><strong>申请通过后如何发布到苹果商店？</strong>
            <br>当您申请成功，喜马拉雅会协助合作伙伴用户直接提交完成，但多数情况下可能需要您自行通过苹果官方渠道提交播客，获取RSS地址后可通过下面的网址进行提交：https://podcastsconnect.apple.com/
            <br>注：RSS地址请在网页端获取！整个提交过程需要通过苹果官方网站完成，请事先拥有一个iTunes账户并登陆：
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_9.png`"  style="width: 530px;height: 270px;">
        <p class="content"><strong>如何获取自己的RSS地址</strong>
            <br>进入方式：个人主页—管理中心—推广中心—Podcast服务随后点击专辑名称，进入以下页面即可显示RSS地址
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_10.png`"  style="width: 620px;height: 220px;">
        <p class="content"><strong>申请成功后为什么搜索不到？</strong>
            <br>一：这可能取决于苹果服务器的更新情况，一般需要24小时左右。
            <br>二：你的节目可能不适宜在苹果商店展示，原因可能如下：你的节目太少，或者已经停止更新；你的封面图片不符合苹果公司的政策法规；你节目中使用的相关素材，涉及到版权风险；内容不适合发布；Podcast不接受此类型作品；您的相关作品无法判断是否获得相关文字及内容版权。
            <br>提示：您可以通过苹果官方网站重新提交申请，但如果因为下架原因，则此专辑将无法进行再次申请。
            <br><br><strong>如何删除Podcast服务？</strong>
            <br>注意：删除Podcast服务将不可再恢复。如果是您自己通过iTunes账号提交的Podcast请自行<a target="_blank" href="https://podcastsconnect.apple.com/">登录</a>管理页面,进行删除；如果是喜马拉雅FM协助您提交的Podcast服务请邮件联系我们进行删除。
            <br><br><strong>关于Podcast相关技术问题</strong>
            <br>请<a href="https://itunespartner.apple.com/cn/podcasts/overview" target="_blank">登录</a>苹果公司网站进行查询
            <br><br><strong>为什么提示&lt;description&gt; 标签错误？</strong>
            <br>请为您的专辑添加简介，或在Podcast设置里面添加自定义“播客描述”：
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_11.jpeg`"  style="width: 430px;height: 190px;">
        <p class="title">3. 主播社群运营策略</p>
        <p class="content">请查看：
            <br><a href="http://blog.ximalaya.com/%e5%96%9c%e9%a9%ac%e6%8b%89%e9%9b%85%e7%a4%be%e7%be%a4%e6%94%bb%e7%95%a51-0/" target="_blank">喜马拉雅社群攻略 1.0</a>
            <br><a href="http://blog.ximalaya.com/%e5%96%9c%e9%a9%ac%e6%8b%89%e9%9b%85%e7%a4%be%e7%be%a4%e6%94%bb%e7%95%a52-0/" target="_blank">喜马拉雅社群攻略  2.0</a> </p>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    computed: {
      IMG_HOST(){
        return this.$store.state.IMG_HOST;
      }
    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>


// WEBPACK FOOTER //
// Popularize.vue?b48b3532